import api from '../../../api/api'
import { SETTING_CONFIG } from '../config.';

export const getGroupsList = async (keyword, setData) => {

    let _params = ''

    if (keyword) {
        _params = '?name=' + keyword;
    }

    const res = await api.get(SETTING_CONFIG.requests.getGroups.url + _params)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const getGroupsInfo = async (groupNo, setData) => {

    const url = SETTING_CONFIG.requests.getGroups.url + `/${groupNo}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}


const groupAdd = async (body, setData) => {


    if (body?.GroupId) {
        const url = SETTING_CONFIG.requests.getGroups.url + `/${body?.GroupNo}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    } else {

        const res = await api.post(SETTING_CONFIG.requests.getGroups.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

}

export const getBranchList = async (BranchNo, setData) => {

    let _params = '';

    if (BranchNo) {
        _params = '?name=' + BranchNo;
    }


    const res = await api.get(SETTING_CONFIG.requests.getBranchs.url + _params)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}


const getBranchInfo = async (branchNo, setData) => {

    const url = SETTING_CONFIG.requests.getBranchs.url + `/${branchNo}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const branchAdd = async (body, setData) => {

    if (body?.BranchId) {
        const url = SETTING_CONFIG.requests.getBranchs.url + `/${body?.BranchNo}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    } else {

        const res = await api.post(SETTING_CONFIG.requests.getBranchs.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }
}

export const getCatalogList = async (keyword, setData) => {

    let _params = '';

    if (keyword) {
        _params = '?name=' + keyword;
    }

    const res = await api.get(SETTING_CONFIG.requests.getGroupCatalogy.url + _params)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const getCatalogInfo = async (CatalogNo, setData) => {

    const url = SETTING_CONFIG.requests.getGroupCatalogy.url + `/${CatalogNo}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}


const catalogAdd = async (body, setData) => {

    if (body?.CatalogId) {
        const url = SETTING_CONFIG.requests.getGroupCatalogy.url + `/${body?.CatalogNo}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    } else {

        const res = await api.post(SETTING_CONFIG.requests.getGroupCatalogy.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }

    }
}

export const getItemMasterList = async (ItemNo, setData) => {


    let _params = '';

    if (ItemNo) {
        _params = '?name=' + ItemNo + '&limit=0'

    }
    _params = '?limit=0';
    const res = await api.get(SETTING_CONFIG.requests.getItemMasters.url + _params)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }

}


// async getItemMasterInfo(ItemNo: string) {

//     const url = SETTING_CONFIG.requests.getItemMasters.url + `/${ItemNo}`;
//     const res = await this.http.get<ResponseAPI>(url).toPromise();
//     return res;
// }

const getItemMasterInfo = async (ItemNo, setData) => {

    const url = SETTING_CONFIG.requests.getItemMasters.url + `/${ItemNo}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const itemMasterAdd = async (body, setData) => {


    if (body?.ItemId) {
        // const url = SETTING_CONFIG.requests.getItemMasters.url + `/${body?.ItemNo}`;
        const url = SETTING_CONFIG.requests.getBranchs.url + `/${body?.BranchNo}/items/${body?.ItemNo}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    } else {

        const res = await api.post(SETTING_CONFIG.requests.getItemMasters.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }

    }
}

const getUnitsList = async (setData) => {

    const res = await api.get(SETTING_CONFIG.requests.getUnits.url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

export const LocationList = async (body, setData) => {
    let _params = ''


    _params = '?' + body.typeSearch + '=' + body.Text


    const res = await api.get(SETTING_CONFIG.requests.searchAddress.url + _params)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const getWherehouseList = async (BranchNo, setData) => {
    const url = SETTING_CONFIG.requests.getBranchs.url + `/${BranchNo}/warehouses`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const getZoneList = async (BranchNo, setData) => {
    const url = SETTING_CONFIG.requests.getBranchs.url + `/${BranchNo}/zones`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const getWherehouseInfo = async (warehouseNo, setData) => {

    const url = SETTING_CONFIG.requests.getWherehouses.url + `/${warehouseNo}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const getZoneInfo = async (zoneNo, setData) => {

    const url = SETTING_CONFIG.requests.getZones.url + `/${zoneNo}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const wherehouseAdd = async (body, setData) => {

    if (body?.WarehouseId) {
        const url = SETTING_CONFIG.requests.getWherehouses.url + `/${body?.WarehouseNo}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    } else {

        const res = await api.post(SETTING_CONFIG.requests.getWherehouses.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }

    }
}

const zoneAdd = async (body, setData) => {

    if (body?.ZoneId) {
        const url = SETTING_CONFIG.requests.getZones.url + `/${body?.ZoneNo}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }

    } else {
        const res = await api.post(SETTING_CONFIG.requests.getZones.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    }

}

export const getCustomers = async (CustomerName, checkAgentExpired, setData) => {

    let _params = '';
    let _customerName = '';
    let _checkAgentExpired = '';

    if (CustomerName) {
        _customerName = 'name=' + CustomerName;
        _params = '?' + _customerName
    }

    if (checkAgentExpired) {
        _checkAgentExpired = 'checkAgentExpired=' + checkAgentExpired;
        _params = '?' + _checkAgentExpired
    }
    if (CustomerName && checkAgentExpired) {
        _params = '?' + _customerName + '&' + _checkAgentExpired
    }

    const res = await api.get(SETTING_CONFIG.requests.getCustomer.url + _params)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const getEmployee = async (setData) => {


    const res = await api.get(SETTING_CONFIG.requests.getEmployee.url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

export const getEmployeeDetail = async (userLogin, setData) => {

    const url = SETTING_CONFIG.requests.getEmployee.url + `/${userLogin}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}


export const getRoles = async (setData) => {
    const res = await api.get(SETTING_CONFIG.requests.getRoles.url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const employeeAdd = async (body, setData) => {

    if (body?.UserId) {
        const url = SETTING_CONFIG.requests.getEmployee.url + `/${body?.UserLogin}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    } else {

        const res = await api.post(SETTING_CONFIG.requests.getEmployee.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }

    }

}


export const getTypesList = async (keyword, setData) => {

    let _params = '';

    if (keyword) {
        _params = '?name=' + keyword;
    }

    const res = await api.get(SETTING_CONFIG.requests.getItemTypes.url + _params)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}

const getTypeInfo = async (TypeNo, setData) => {

    const url = SETTING_CONFIG.requests.getItemTypes.url + `/${TypeNo}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}


const itemTypeAdd = async (body, setData) => {

    if (body?.TypeId) {
        const url = SETTING_CONFIG.requests.getItemTypes.url + `/${body?.TypeNo}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    } else {

        const res = await api.post(SETTING_CONFIG.requests.getItemTypes.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }

    }
}


export const getBudgetYearList = async (setData) => {

    let _params = '';


    const res = await api.get(SETTING_CONFIG.requests.getBudgetYears.url + _params)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }

}


const getBudgetYearInfo = async (Year, setData) => {

    const url = SETTING_CONFIG.requests.getBudgetYears.url + `/${Year}`;
    const res = await api.get(url)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }

}


const budgetYearAdd = async (body, setData) => {

    if (body?.BudgetYearId) {
        const url = SETTING_CONFIG.requests.getBudgetYears.url + `/${body?.BudgetYear}`;
        const res = await api.put(url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }
    } else {

        const res = await api.post(SETTING_CONFIG.requests.getBudgetYears.url, body)
        const data = res.data
        if (data.status === true) {
            setData(data.result)
        }

    }
}

const ChangePassword = async (body, setData) => {
    const res = await api.put(SETTING_CONFIG.requests.ChangePassword.url, body)
    const data = res.data
    if (data.status === true) {
        setData(data.result)
    }
}




